export class InputStyleController {
    constructor(host, options = {}) {
        this.host = host;
        this.options = options;
        this.getInput = options.getInput || (() => null);

        this.inputObserver = new MutationObserver((mutationList, observer) => {
            this.observeInput(mutationList, observer);
        });
        this.inputObserverConfig = {
            attributes: true,
            attributeFilter: ['readonly', 'disabled', 'required'],
        };
    }

    initHandlers() {
        this.removeHandlers();
        this.addHandlers();
    }

    removeHandlers() {
        this.getInput()?.removeEventListener('input', this.handleInput);
        this.getInput()?.removeEventListener('invalid', this.handleInvalid);
    }

    addHandlers() {
        if (!this.getInput()?.form) {
            return;
        }

        this.getInput()?.addEventListener('input', this.handleInput);
        this.getInput()?.addEventListener('invalid', this.handleInvalid);
    }

    observeInput(mutationList) {
        for (const { type, attributeName } of mutationList) {
            if (type === 'attributes') {
                this.calcInputAttr(attributeName);
            }
        }
    }

    calcInputAttr(attributeName = '') {
        if (attributeName?.length > 0) {
            this.host[attributeName] = this.getInput()?.hasAttribute(attributeName);
            return;
        }

        if (!this.inputObserverConfig.attributeFilter) {
            return;
        }

        for (const attr of this.inputObserverConfig.attributeFilter) {
            this.host[attr] = this.getInput()?.hasAttribute(attr);
        }
    }

    _setErrorMessage(message = '') {
        if (message?.length <= 0) {
            message = this.getInput()?.validationMessage;
        }

        if (message) {
            this.host?.setAttribute('error', '');
            this.host?.setAttribute('error-text', message);
        } else {
            this.host?.removeAttribute('error', '');
            this.host?.removeAttribute('error-text');
        }
    }

    handleInput = () => {
        if (this.host?.hasAttribute('error')) {
            this.host.removeAttribute('error');
            this.host.removeAttribute('error-text');
        }
    };

    handleInvalid = () => {
        this._setErrorMessage(this.getInput()?.validationMessage);
        const scrollOptions = { behavior: 'auto', block: 'start' };
        this.getInput()?.scrollIntoView(scrollOptions);
    };
}
